import { createFileRoute } from '@tanstack/react-router'

import { BreadcrumbTrail, PageHeader } from '@/components/ui'
import { DocumentsList, useDocumentsWebsocket } from '@/modules/documents'

export const Route = createFileRoute('/_authenticated/documents/')({
  staticData: { title: 'Documents' },
  component: DocumentsListView,
  shouldReload: false,
})

function DocumentsListView() {
  useDocumentsWebsocket()

  return (
    <div className="space-y-6">
      <BreadcrumbTrail page="Documents" />

      <PageHeader title="Documents" subtitle="Documents list." />

      <DocumentsList />
    </div>
  )
}
